// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"179":"2b1aac5e","967":"ca2303f2"}[chunkId] + ".js";
};